import { type IAttribute } from '../models/Attributes'

interface TransformedAttribute {
  title: string
  value: string
}

export const transformAttributesListForDropdown = (attributesList: IAttribute[]): TransformedAttribute[] => {
  return attributesList?.map((attribute: { attributeValues: any[], attributeKey: any }) =>
    attribute.attributeValues?.map((value) => ({
      title: attribute.attributeKey,
      value
    }))
  ).flat()
}
